import axios from 'axios'
// { AxiosResponse, AxiosRequestConfig }
// import camelCaseKeys from "camelcase-keys"

const BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 0,
  responseType: 'json',
  headers: {
    Accept: `application/json`,
    'Content-Type': `application/json`,
    'Access-Control-Allow-Origin': `*`,
  },
})

// http.interceptors.response.use(
//   function(response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     const came =  camelCaseKeys(response.data, { deep: true })
//     return {
//       ...response,
//       data: came,
//     }
//   },
//   function(error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     return Promise.reject(error)
//   }
// )
// http.interceptors.request.use(
//   request => {
//   if (Array.isArray(request.data)) {
//     snakecaseKeys([{'foo-bar': true}, {'bar-foo': false}]);
//     //=> [{fooBar: true}, {barFoo: false}]
//     // camalize an array
//   } else {
//     const camel =  camelCaseKeys(request.data, { deep: true })
//   // camazlie an object
//   }
//   return { request }
//   },
//   error => {
//   // i dunno, do something with the error
//   },
//   )

// http.interceptors.request.use(
//   function (config) {
//   // Do something before request is sent
//   const requestData =()=>{

//   }
//   return config;
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });

export { http }
